import React from 'react'
import PropTypes from 'prop-types'
import InputWrapper from './InputWrapper'
import { Button } from 'antd'

const SubmitButton = ({
  label,
  formItemOptions = {},
  children = 'Submit',
  btnStyle = {},
  ...rest
}) => {
  return (
    <InputWrapper label={label} {...formItemOptions}>
      <Button type="primary" htmlType="submit" {...rest} style={btnStyle}>
        {children}
      </Button>
    </InputWrapper>
  )
}

SubmitButton.propTypes = {
  label: PropTypes.string,
  formItemOptions: PropTypes.object,
  btnStyle: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
}

export default SubmitButton
